import React, { Suspense } from 'react';
import { CrewMember } from '@bechtel/types';
import {
  ErrorBoundary,
  UnderConstruction,
  SuspenseLoader,
  CacheKeys,
  useSessionStorage,
  useAppUser,
} from '@bechtel/client-common';
import { DashboardHeader } from '~/header';
import { DashboardPersonaContainerStyled } from '~/styled';
import { useDashboardPermissions } from '@bechtel/client-dashboard-common';
import { DashboardContainerStyled } from './styled';
import { UserSelector } from '@bechtel/client-dashboard-common';
import { DashboardContent } from '~/content';

const WeldDashboardView = () => {
  const [selectedCrewMember, setSelectedCrewMember] = useSessionStorage<CrewMember | null>(
    CacheKeys.DashboardSelectedUser,
    null
  );
  //All the dashboard default canView properties are mutually exclusive only one or none will be true at a time
  const { canViewOtherUserDashboard, hasNoDefaultDashboard } = useDashboardPermissions();
  const { user } = useAppUser();
 
  return (
    <DashboardContainerStyled>
      {hasNoDefaultDashboard ? (
        <UnderConstruction />
      ) : (
        <ErrorBoundary>
          <Suspense fallback={<SuspenseLoader></SuspenseLoader>}>
            <DashboardPersonaContainerStyled>
              <DashboardHeader crewMember={selectedCrewMember || user?.crewMember} />
              {canViewOtherUserDashboard && (
                <UserSelector
                  selectedCrewMember={selectedCrewMember}
                  setSelectedCrewMember={setSelectedCrewMember}
                  isWeldDashboard={true}
                />
              )}
              <DashboardContent selectedCrewMember={selectedCrewMember} />
            </DashboardPersonaContainerStyled>
          </Suspense>
        </ErrorBoundary>
      )}
    </DashboardContainerStyled>
  );
};

export default WeldDashboardView;
